import { useCallback, useEffect, useState } from "react";
import { getStatsApi } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";

/**
 * Shared stats fetching hook (Dashboard + Progress).
 * `getStatsApi` is a stable module import; state setters are stable per React
 * guarantees — so `profile.id` is the only reactive dependency.
 */
export const useStats = () => {
  const { profile } = useProfile();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const data = await getStatsApi(profile.id);
      setStats(data);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [profile.id]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { stats, loading, error, reload };
};
